import { useMap } from "react-leaflet";
import { useEffect } from "react";

function RecenterMap({ center }) {
  const map = useMap();

  useEffect(() => {
    if (center) {
      map.setView(center, map.getZoom()); // mueve el centro pero mantiene el zoom actual
    }
  }, [center, map]);

  return null;
}

export default RecenterMap;
